import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetGuestRidesCountRowsQueryVariables = Types.Exact<{
  scope: Types.Guestrides_Bool_Exp;
  window: Types.Guestrides_Bool_Exp;
}>;


export type GetGuestRidesCountRowsQuery = { __typename?: 'query_root', upcoming: Array<{ __typename?: 'guestrides', id: number, customer_id: number }>, active: Array<{ __typename?: 'guestrides', id: number, customer_id: number }>, completed: Array<{ __typename?: 'guestrides', id: number, customer_id: number }>, cancelled: Array<{ __typename?: 'guestrides', id: number, customer_id: number }> };


export const GetGuestRidesCountRowsDocument = gql`
    query getGuestRidesCountRows($scope: guestrides_bool_exp!, $window: guestrides_bool_exp!) {
  upcoming: guestrides(
    where: {_and: [$scope, $window, {status: {_in: ["new", "failed"]}}]}
  ) {
    id
    customer_id
  }
  active: guestrides(
    where: {_and: [$scope, $window, {status: {_in: ["pending", "booked", "driver_enroute", "driver_arrived", "riding"]}}]}
  ) {
    id
    customer_id
  }
  completed: guestrides(
    where: {_and: [$scope, $window, {status: {_in: ["completed"]}}]}
  ) {
    id
    customer_id
  }
  cancelled: guestrides(
    where: {_and: [$scope, $window, {status: {_in: ["cancelled"]}}]}
  ) {
    id
    customer_id
  }
}
    `;

/**
 * __useGetGuestRidesCountRowsQuery__
 *
 * To run a query within a React component, call `useGetGuestRidesCountRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestRidesCountRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestRidesCountRowsQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      window: // value for 'window'
 *   },
 * });
 */
export function useGetGuestRidesCountRowsQuery(baseOptions: Apollo.QueryHookOptions<GetGuestRidesCountRowsQuery, GetGuestRidesCountRowsQueryVariables> & ({ variables: GetGuestRidesCountRowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGuestRidesCountRowsQuery, GetGuestRidesCountRowsQueryVariables>(GetGuestRidesCountRowsDocument, options);
      }
export function useGetGuestRidesCountRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGuestRidesCountRowsQuery, GetGuestRidesCountRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGuestRidesCountRowsQuery, GetGuestRidesCountRowsQueryVariables>(GetGuestRidesCountRowsDocument, options);
        }
// @ts-ignore
export function useGetGuestRidesCountRowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGuestRidesCountRowsQuery, GetGuestRidesCountRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGuestRidesCountRowsQuery, GetGuestRidesCountRowsQueryVariables>;
export function useGetGuestRidesCountRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGuestRidesCountRowsQuery, GetGuestRidesCountRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGuestRidesCountRowsQuery | undefined, GetGuestRidesCountRowsQueryVariables>;
export function useGetGuestRidesCountRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGuestRidesCountRowsQuery, GetGuestRidesCountRowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGuestRidesCountRowsQuery, GetGuestRidesCountRowsQueryVariables>(GetGuestRidesCountRowsDocument, options);
        }
export type GetGuestRidesCountRowsQueryHookResult = ReturnType<typeof useGetGuestRidesCountRowsQuery>;
export type GetGuestRidesCountRowsLazyQueryHookResult = ReturnType<typeof useGetGuestRidesCountRowsLazyQuery>;
export type GetGuestRidesCountRowsSuspenseQueryHookResult = ReturnType<typeof useGetGuestRidesCountRowsSuspenseQuery>;
export type GetGuestRidesCountRowsQueryResult = Apollo.QueryResult<GetGuestRidesCountRowsQuery, GetGuestRidesCountRowsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * Multiple root fields (upcoming, active, completed, cancelled): returns the full response object.
 * @source {@link src/features/guestRides/counts/getGuestRidesCountRows.query.gql}
 */
export async function getGuestRidesCountRows(
  variables: GetGuestRidesCountRowsQueryVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<GetGuestRidesCountRowsQuery> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).query<GetGuestRidesCountRowsQuery>(
    GetGuestRidesCountRowsDocument,
    variables,
    requestOptions
  )
}